export enum ListRolesSort {
  UNSET_LIST_BRAND_ROLES_SORT = 'UNSET_LIST_BRAND_ROLES_SORT', // Do not use, needed because of proto3 limitations
  LIST_BRAND_ROLES_SORT_NAME = 'LIST_BRAND_ROLES_SORT_NAME',
  LIST_BRAND_ROLES_SORT_COUNT = 'LIST_BRAND_ROLES_SORT_COUNT',
  LIST_BRAND_ROLES_BRAND = 'LIST_BRAND_ROLES_BRAND',
}
